<template>
  <nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary"
    itemtype="https://schema.org/SiteNavigationElement" itemscope>
    <div class="inside-navigation">
      <div class="navigation-branding">
        <div class="site-logo">
          <a href="https://gbwaapplus.com/" title="GBWhatsApp" rel="home">
            <img class="header-image is-logo-image" alt="GBWhatsApp" src="../assets/logo.webp" title="GBWhatsApp">
          </a>
        </div>
        <p class="main-title" itemprop="headline">
          <a href="https://gbwaapplus.com/" rel="home">
            GB WhatsApp
          </a>
        </p>
      </div>
      <ul id="menu-primary-menu" class="menu sf-menu mobile-menu-page" v-show="isMenuClicked">
        <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="https://gbwaapplus.com/gb-whatsapp-apk-download/">Download</a>
        </li>
        <li v-if="update" id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33" @click="scrollToTarget">
            <a href="javascript:void(0)">Update</a>
        </li>
        <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="https://gbwaapplus.com/ob-whatsapp/"> OB WhatsApp</a>
        </li>
        <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="https://gbwaapplus.com/gb-whatsapp-for-pc/">For PC</a>
        </li>
        <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="https://gbwaapplus.com/gb-whatsapp-ios/">For iOS</a>
        </li>
        <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="https://gbwaapplus.com/gbwhatsapp-ban-issues/">Anti Ban</a>
        </li>
      </ul>

      <div id="primary-menu" class="main-nav">
        <!-- mobile -->
        <div class="mobile-menu" v-if="$global.isMobileDevice()">
          <div class="menu-toggle" @click="isMenuClicked = !isMenuClicked">
            <img src="@/assets/menu.svg" alt="menu button" v-if="!isMenuClicked">
            <img src="@/assets/xmark-black.svg" alt="close button" v-else>
          </div>
        </div>
        <!-- pc -->
        <ul v-else id="menu-primary-menu" class="menu sf-menu">
          <li v-if="update" id="menu-item-29" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 " @click="scrollToTarget">
            <a href="javascript:void(0)">Update</a>
          </li>

          <li id="menu-item-30" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 ">
            <a @mouseenter="isMods = true" @mouseleave="isMods = false" class="has-sub-menu">Altermative Mods<svg width="24"
                height="24" viewBox="0 0 24 24 24" fill="none" xmlns="https://www.w3.org/2000/svg">
                <path d="M6 9L12 15L18 9" stroke="black" stroke-width="1.5">
                </path>
              </svg></a>
            <ul class="sub-menu" v-show="isMods" @mouseenter="isMods = true" @mouseleave="isMods = false">
              <li @click="goJump('https://gbwaapplus.com/ob-whatsapp/')"> OB WhatsApp</li>
            </ul>
          </li>
          <li id="menu-item-31" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 ">
            <a @mouseenter="isPCShow = true" @mouseleave="isPCShow = false" class="has-sub-menu">Devices<svg width="24"
                height="24" viewBox="0 0 24 24 24" fill="none" xmlns="https://www.w3.org/2000/svg">
                <path d="M6 9L12 15L18 9" stroke="black" stroke-width="1.5">
                </path>
              </svg></a>
            <ul class="sub-menu" v-show="isPCShow" @mouseover="isPCShow = true" @mouseleave="isPCShow = false">
              <li @click="goJump('https://gbwaapplus.com/gb-whatsapp-for-pc/')">For PC</li>
              <li @click="goJump('https://gbwaapplus.com/gb-whatsapp-ios/')">For iOS</li>
            </ul>
          </li>
          <li id="menu-item-32" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 ">
            <a href="https://gbwaapplus.com/gbwhatsapp-ban-issues/">Anti Ban</a>

          </li>
          <li id="menu-item-33"
            class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 header-download">
            <a class="download-btn" href="https://gbwaapplus.com/gb-whatsapp-apk-download/">Download</a>
          </li>

        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import Search from './Search.vue';
export default {
  props: {
    update:{
      type: String,
      default: '',
    },
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
  },
  components: {
    Search,
  },
  data() {
    return {
      isHovered: false,
      isMenuClicked: false,
      isModClicked: false,
      isSearchClicked: false,
      apk: null,
      isPCShow: false,
      isMods: false,
      options: [
        { value: 'en', label: 'English' },
        { value: 'ar', label: 'العربية' },
        { value: 'id', label: 'Bahasa Indonesia' },
      ],
      selectValue: null,
      lang: [{
        lang: 'en',
        val: '🇺🇸 English'
      },
      {
        lang: 'ar',
        val: '🇦🇪 اَلْعَرَبِيَّةُ'
      },
      {
        lang: 'id',
        val: '🇮🇩 Bahasa Indonesia'
      },
      {
        lang: 'pt',
        val: '🇵🇹 Português'
      },
      {
        lang: 'es',
        val: '🇪🇸 Español'
      },
      {
        lang: 'hi',
        val: '🇮🇳 हिंदी'
      },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          blogs: 'Blogs',
          mod: 'WhatsApp Mods',
        },
        ar: {
          home: 'الصفحة الرئيسية',
          download: 'تحميل',
          blogs: 'المدونات',
          mod: 'مودات واتس اب',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          blogs: 'Blog',
          mod: 'Mod WhatsApp',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
          mod: 'Mods do WhatsApp',
        },
        es: {
          home: 'Casa',
          download: 'Descargar',
          blogs: 'Blogs',
          mod: 'Mods de WhatsApp',
        },
        hi: {
          home: 'घर',
          download: 'डाउनलोड',
          blogs: 'ब्लॉग',
          mod: 'व्हाट्सएप मोड्स',
        },
      },
    }
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    }
  },
  mounted() {
    this.getOfficalApk();
  },
  methods: {
    scrollToTarget(){
     this.$emit('scroll-to-target')
    },
    changeLanguage(lang) {
      console.log("changelang: ", lang);
      console.log("page: ", this.page);
      this.$router.push({
        name: `${this.selectedLanguage}-${this.page}`
      });
    },
    handleCommand(command) {
      console.log(command);
      // window.open("https://gbwaapplus.com/gbwhatsapp-blogs/", "_blank");
    },
    downloadApk() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    goJump(link) {
      window.location.href = link;
    },
    download() {
      if (typeof this.gotodownload === "function") {
        this.gotodownload();
      } else {
        console.error("gotodownload is not a function");
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100% !default;

#site-navigation {
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.5);

  .inside-navigation {
    width: 80%;
    margin: 0 auto;
    z-index: 9999;
    height: 80px;
    position: relative;
  }
}

.header-download {
  color: #fff !important;
  // width: 80% ;
  margin: auto;
  font-size: 18px !important;
  font-family: inherit !important;
  font-weight: 600 !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

#backtop {
  width: 30px;
  height: 30px;
  position: fixed;
  right: 50px;
  bottom: 100px;
  background: #f0f0f0;
  padding: 10px;
  border-radius: 50%;
  box-sizing: content-box;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.main-nav {
  .menu {
    list-style-type: none !important;
    margin: 0 !important;

    li {
      a {
        font-weight: 500 !important;
      }
    }
  }
}

.sub-menu {
  position: absolute;
  list-style: none !important;
  // margin-top: 20px !important;
  padding-top: 14px;
  cursor: pointer;

  li {
    padding: 10px;
    background: #fff;
    // color: #fff;
    // border-radius: 8px;
    border-bottom: 1px solid #f0f0f0;

    &:hover {
      background: #f0f0f0;
    }
  }
}

.has-sub-menu {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
}

@media screen and (max-width: 768px) {

  .inside-navigation {

    .mobile-menu-page {
      position: absolute;
      top: 100%;
      width: 100%;
      z-index: 1001;
      margin: 0 !important;

      .menu-item {
        padding: 14px 0;
        margin-bottom: 0 !important;
        background: #fff;
        cursor: pointer;

        a,
        div {
          cursor: pointer;
          font-size: 15px;
          text-align: center;
          color: #121212;
          display: block;
        }
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      position: relative;

      .language-selector {
        width: 60%;

        #language-select {
          width: 100%;
        }
      }

      .menu-toggle {
        display: block;
        display: flex;
        justify-content: center;
        padding: 12px 12px;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }

      .search-toggle {
        display: block;
        padding: 12px 12px;
        display: flex;
        justify-content: center;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
